import React, { useContext, useState } from 'react';
import { FormRepositoryFactory, FormRepositoryInterface } from 'application/repositories/formRepository';

interface ExtendedFormContext extends Partial<FormRepositoryInterface> {
	isOpen: boolean;
	isLoading: boolean;
	open: () => void;
	close: () => void;
}

const FormContext = React.createContext<ExtendedFormContext>({
	isOpen: false,
	isLoading: false,
	open: () => {},
	close: () => {},
});

export interface FormContextProviderProps {
	children?: React.ReactNode;
	formData: Form.ContactForm;
}

export const FormContextProvider: React.FC<FormContextProviderProps> = (props) => {
	const formRepository = FormRepositoryFactory();

	const [isOpen, setIsOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	return (
		<FormContext.Provider
			value={{
				...formRepository,
				isOpen,
				isLoading,
				open: () => {
					setIsLoading(true);
					setIsOpen(true);
					setTimeout(() => setIsLoading(false), 100);
				},
				close: () => {
					setIsOpen(false);
					setIsLoading(false);
				},
			}}
		>
			{props.children}
		</FormContext.Provider>
	);
};

export function useFormContext(): ExtendedFormContext {
	return useContext(FormContext);
}
